import { Modal } from 'react-bootstrap';
import CountdownTimer from '../../components/CountDownTimer';
import 'react-modern-drawer/dist/index.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Drawer from 'react-modern-drawer';
import './style.css';
import type { ITariffDetailsProps } from '../../types/propTypes';
import { useTariffDetails } from './hooks/TariffDetailsHook';

const TariffDetails = (props: ITariffDetailsProps) => {
    const {
        t,
        showModal,
        connectorId,
        details,
        holding,
        drawerOpen,
        connectorDetails,
        showTariffBreakdownModal,
        isDesktop,
        setDrawerOpen,
        onHide,
        startHold,
        stopHold,
        checkTariffAvailability,
        renderComponent,
    } = useTariffDetails(props);

    return (
        <div>
            {isDesktop ? (
                <Modal
                    className={showTariffBreakdownModal ? 'modal-fade-background' : ''}
                    show={showModal}
                    onHide={onHide}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{t<string>('stationDetails.tariffDetailsModal.tariffDetails')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <div className="connector-details d-flex flex-column flex-md-row mb-3">
                                <div className="connector-imagebackground">
                                    <img
                                        className="connector-image"
                                        style={{ height: '25px' }}
                                        src={connectorDetails?.image}
                                        alt="connector"
                                    />
                                </div>
                                <div className="d-flex flex-column justify-content-center">
                                    <span>{connectorDetails?.name}</span>
                                    {connectorDetails?.power && (
                                        <span style={{ fontSize: '0.9em' }}>
                                            {`${t(
                                                'stationDetails.tariffDetailsModal.upto',
                                            )} ${connectorDetails.power.replace(/\s*(kW)/i, 'kW')}`}
                                        </span>
                                    )}
                                </div>
                            </div>
                            {holding && (
                                <div className="spinner">
                                    <CountdownTimer holding={holding} onComplete={checkTariffAvailability} />
                                </div>
                            )}
                            {renderComponent()}
                        </div>
                    </Modal.Body>

                    <Modal.Footer className="padding-bottom-10 mt-3">
                        {details.charge_station_status.code === 'AVAILABLE' && (
                            <button
                                className={`charging-button px-4 fw-bold w-100`}
                                aria-label="Hold to Charge"
                                onMouseDown={startHold}
                                onTouchStart={startHold}
                                onMouseUp={stopHold}
                                onTouchEnd={stopHold}
                                onMouseLeave={stopHold}
                                onTouchCancel={stopHold}
                                disabled={connectorId === 0}
                            >
                                {t<string>('stationDetails.button.holdToCharge')}
                            </button>
                        )}
                    </Modal.Footer>
                </Modal>
            ) : (
                <div>
                    <Drawer
                        open={drawerOpen}
                        onClose={onHide}
                        direction="bottom"
                        style={{
                            height: 'auto',
                        }}
                        size="80vh"
                        className={`py-0 drawer ${showTariffBreakdownModal ? 'modal-fade-background' : ''}`}
                        lockBackgroundScroll={true}
                    >
                        <div className={`drawer-content ${showTariffBreakdownModal ? 'blur-content' : ''}`}>
                            <div className="drawer-header">
                                <h3 style={{ fontWeight: 'bold', margin: 0 }} className="mt-3">
                                    {t<string>('stationDetails.tariffDetailsModal.tariffDetails')}
                                </h3>
                                <button
                                    onClick={() => {
                                        setDrawerOpen(false);
                                        onHide();
                                    }}
                                    className="close-btn"
                                    aria-label="Close"
                                >
                                    ×
                                </button>
                            </div>
                            <div className="detailcontainer">
                                <div className="connector-details mb-3">
                                    <div className="connector-imagebackground">
                                        <img
                                            className="connector-image"
                                            style={{ height: '25px' }}
                                            src={connectorDetails?.image}
                                            alt="connector"
                                        />
                                    </div>
                                    <span className="mt-1">{connectorDetails?.name}</span>
                                    <span>
                                        {connectorDetails?.power && (
                                            <span
                                                style={{
                                                    fontSize: '0.9em',
                                                    marginLeft: 0,
                                                }}
                                            >
                                                {`${t(
                                                    'stationDetails.tariffDetailsModal.upto',
                                                )} ${connectorDetails.power.replace(/\s*(kW)/i, 'kW')}`}
                                            </span>
                                        )}
                                    </span>
                                </div>
                                {holding && (
                                    <div className="spinner">
                                        <CountdownTimer holding={holding} onComplete={checkTariffAvailability} />
                                    </div>
                                )}

                                {renderComponent()}
                            </div>
                            <div className="my-3">
                                {details.charge_station_status.code === 'AVAILABLE' && (
                                    <button
                                        className="charging-button px-4 fw-bold w-100"
                                        aria-label="Hold to Charge"
                                        onMouseDown={startHold}
                                        onTouchStart={startHold}
                                        onMouseUp={stopHold}
                                        onTouchEnd={stopHold}
                                        onMouseLeave={stopHold}
                                        onTouchCancel={stopHold}
                                        disabled={connectorId === 0}
                                    >
                                        {t<string>('stationDetails.button.holdToCharge')}
                                    </button>
                                )}
                            </div>
                        </div>
                    </Drawer>
                </div>
            )}
        </div>
    );
};

export default TariffDetails;
